import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Slider } from 'antd'
import styled from 'styled-components'

const propTypes = {}

// styled components
const LeadTitleArea = styled.div`
  background-color: transparent;
  padding-top: 2px;
  padding-left: 5px;
  padding-right: 5px;
`

const statusMarks = {
  0: 'Research',
  25: 'Estimate',
  50: 'Proposal',
  75: 'Contract',
  100: {
    label: <strong>Complete</strong>
  }
}

class LeadTitle extends Component {
  transformLeadStatus = status => {
    switch (status) {
      case 'estimate':
        return 25
      case 'proposal':
        return 50
      case 'contract':
        return 75
      case 'complete':
        return 100
      default:
        return 0
    }
  }

  render() {
    const { payload } = this.props.leadDetails
    if (payload && payload.data) {
      return (
        <LeadTitleArea>
          <div className="row">
            <div className="col-lg-5 col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/leads">Leads</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {payload.data.name}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-none d-sm-block col-lg-7 col-md-6">
              <div className="steps">
                <Slider
                  marks={statusMarks}
                  step={null}
                  value={this.transformLeadStatus(payload.data.status)}
                  disabled={!this.props.isEditing}
                  tipFormatter={null}
                  onChange={this.props.handleLeadStatusChange}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 LeadTitle">
              <h2>
                <i className="fa fa-map-marker" aria-hidden="true" />
                {payload.data.name}
              </h2>
            </div>
          </div>
        </LeadTitleArea>
      )
    } else {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ leadDetails }, ownProps) => ({
  leadDetails
})

LeadTitle.propTypes = propTypes
export default withRouter(connect(mapStateToProps)(LeadTitle))



// WEBPACK FOOTER //
// ./src/components/LeadTitle.js